import { graphql, useStaticQuery } from 'gatsby'

import { PostType } from '@contracts/Posts'

interface Props {
	featuredOnly?: boolean
}

const useNewsPosts = (props: Props) => {
	const data = useStaticQuery(graphql`
		query AllNewsPosts {
			allWpPost(sort: { date: DESC }) {
				nodes {
					id
					uri
					title
					date(formatString: "DD MMMM YYYY")
					excerpt
					isSticky
					featuredImage {
						node {
							mimeType
							altText
							localFile {
								childImageSharp {
									gatsbyImageData(width: 500, placeholder: BLURRED)
								}
							}
						}
					}
					newsArticleOptions {
						alternateImage {
							mimeType
							altText
							localFile {
								childImageSharp {
									gatsbyImageData(width: 500, placeholder: BLURRED)
								}
							}
						}
					}
				}
			}
		}
	`)

	let posts = data.allWpPost.nodes as PostType[]

	if (props.featuredOnly) {
		posts = posts.filter((post) => post.isSticky)
	}

	return posts
}

export default useNewsPosts
